/** Páginas legales del sitio (/privacy y /terms). Publicadas sin enlace en los menús. */
import Marco, { Navegacion, useMeta } from './Marco';
import { useIdiomaSitio } from './idioma';
import LEGAL from './textosLegales';

/** Párrafos en orden; las viñetas seguidas ("• …") se agrupan en una lista. */
function bloques(parrafos) {
  const out = [];
  for (const p of parrafos) {
    if (p.startsWith('• ')) {
      const ultimo = out[out.length - 1];
      if (Array.isArray(ultimo)) ultimo.push(p.slice(2)); else out.push([p.slice(2)]);
    } else out.push(p);
  }
  return out.map((b, i) => Array.isArray(b)
    ? <ul key={i} style={{ listStyle: 'disc', margin: '12px 0 0', paddingLeft: 22, color: '#3D4358', display: 'flex', flexDirection: 'column', gap: 8 }}>{b.map(v => <li key={v}>{v}</li>)}</ul>
    : <p key={i} style={{ margin: '12px 0 0', color: '#3D4358' }}>{b}</p>);
}

export default function Legal({ doc }) {
  const idioma = useIdiomaSitio(s => s.idioma);
  const d = LEGAL[doc][idioma];
  useMeta(`${d.titulo} · Finance 360`);
  return (
    <Marco>
      <div style={{ borderBottom: '1px solid #E2E5EF' }}><Navegacion tono="clara" /></div>
      <main className="caja" style={{ maxWidth: 820, paddingTop: 80, paddingBottom: 110 }}>
        <h1 className="display" style={{ fontWeight: 800, fontSize: 'clamp(36px,4.4vw,56px)', color: '#1A1D4E' }}>{d.titulo}</h1>
        <p className="mono suave" style={{ fontSize: 13, margin: '14px 0 0' }}>{d.actualizado}</p>
        <p className="suave" style={{ fontSize: 18, margin: '28px 0 0' }}>{d.intro}</p>
        {d.secciones.map(([titulo, parrafos]) => (
          <section key={titulo} style={{ marginTop: 40 }}>
            <h2 className="display" style={{ fontWeight: 700, fontSize: 22, color: '#1A1D4E', letterSpacing: '-.01em' }}>{titulo}</h2>
            {bloques(parrafos)}
          </section>
        ))}
      </main>
    </Marco>
  );
}
